// extracted by mini-css-extract-plugin
export var closeButton = "_bw-1";
export var closeX = "_bw-3";
export var container = "_bw-0";
export var image = "_bw-2";